module.exports = ".canvas-container{cursor:crosshair;margin-top:100px}.invisible{display:none}\n"